import React, { forwardRef } from "react";

import Alert, { AlertColor } from "@mui/material/Alert";
import { SnackbarContent, CustomContentProps, closeSnackbar } from "notistack";

// eslint-disable-next-line react/display-name
const StandardSnackBar = forwardRef<HTMLDivElement, CustomContentProps>(
  (props, ref) => {
    const { id, message, variant, ...other } = props;

    return (
      <SnackbarContent ref={ref} role="alert" {...other}>
        <Alert
          severity={variant as AlertColor}
          onClose={() => {
            closeSnackbar(id);
          }}
          sx={{ width: "100%" }}
          variant="filled"
        >
          {message}
        </Alert>
      </SnackbarContent>
    );
  },
);

export default StandardSnackBar;
